export default __webpack_public_path__ + "static/media/vip1.a8f9c694.webp";